type Dispatch = (action: any) => any

interface DeactivateAgreementAndLogOutArgs {
    agreementToDeactivate: any
    dispatch: Dispatch
    getState: () => { consents: { error: any } }
    updateStatusError: (payload: any) => any
    updateAgreementStatus: (agreement: any, newStatus: string) => any
    forceLogOut: () => void
    logOut: () => any
    hideAgreementDeactivationPopup: () => any
}

export const deactivateAgreementAndLogOut = async ({
    agreementToDeactivate,
    dispatch,
    getState,
    updateStatusError,
    updateAgreementStatus,
    forceLogOut,
    logOut,
    hideAgreementDeactivationPopup,
}: DeactivateAgreementAndLogOutArgs) => {
    dispatch(updateStatusError(null))
    await dispatch(updateAgreementStatus(agreementToDeactivate, "false"))

    if (!getState().consents.error) {
        forceLogOut()
        dispatch(logOut())
        dispatch(updateStatusError(null))
        dispatch(hideAgreementDeactivationPopup())
        return true
    }

    return false
}

export default deactivateAgreementAndLogOut
